import React from "react"
import styled from "styled-components"
import { ChildrenProps } from "../../@types/@core"
import { breakpoint } from "../../styles"

const MosaicWrapper = styled.div`
	display: grid;
	width: 100%;
	grid-template-columns: repeat(2, 1fr);
	grid-template-rows: repeat(3, 1fr);

	${breakpoint("m")`
		grid-template-columns: repeat(4, 1fr);
		grid-template-rows: repeat(8, 1fr);
		`}

	& > div {
		position: relative;
		display: block;

		&:nth-child(1) {
			grid-column: 1/2;
			grid-row: 1/2;
		}
		&:nth-child(2) {
			grid-column: 2/3;
			grid-row: 2/3;
		}
		&:nth-child(3) {
			grid-column: 1/2;
			grid-row: 3/4;
		}
		&:nth-child(4) {
			grid-column: 2/3;
			grid-row: 1/2;
		}
		&:nth-child(5) {
			grid-column: 1/2;
			grid-row: 2/3;
		}
		&:nth-child(6) {
			grid-column: 2/3;
			grid-row: 3/4;
		}

		${breakpoint("m")`
			&:nth-child(1) {
				grid-column: 1/2;
				grid-row: 1/4;
			}
			&:nth-child(2) {
				grid-column: 4/5;
				grid-row: 2/5;
			}
			&:nth-child(3) {
				grid-column: 2/3;
				grid-row: 5/-2;
			}
			&:nth-child(4) {
				grid-column: 2/4;
				grid-row: 1/5;
			}
			&:nth-child(5) {
				grid-column: 1/2;
				grid-row: 5/-2;
			}
			&:nth-child(6) {
				grid-column: 3/5;
				grid-row: 5/-1;
				`}
	}

	& > img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: left;
		position: absolute;
	}
`

const Mosaic: React.FC<ChildrenProps> = (props) => {
	return (
		<MosaicWrapper>
			<div>{props.children[0]}</div>
			<div>{props.children[1]}</div>
			<div>{props.children[2]}</div>
			<div>{props.children[3]}</div>
			<div>{props.children[4]}</div>
			<div>{props.children[5]}</div>
		</MosaicWrapper>
	)
}

export { Mosaic }
